import { FC } from "react";
import { Card, Stack, Typography, styled } from "@mui/material";
import { PatientDetailsWithId } from "../types";
import AvatarInitialsProfile from "./AvatarInitialsProfile";
import { Link } from "react-router-dom";
import { grey } from "@mui/material/colors";

const DashboardPatientContainer = styled(Card)({
  padding: "1rem",
  ":hover": { backgroundColor: grey[100] },
});

const PatientLink = styled(Link)({
  textDecoration: "none",
});

interface DashboardPatientCardProps {
  patient: PatientDetailsWithId;
}

const DashboardPatientCard: FC<DashboardPatientCardProps> = ({
  patient: { firstName, lastName, patientId },
}) => {
  return (
    <PatientLink to={`/patients/${patientId}`}>
      <DashboardPatientContainer variant="outlined">
        <Stack spacing={2} direction="row" alignItems="center">
          <AvatarInitialsProfile firstName={firstName} lastName={lastName} />
          <Typography variant="body1">
            {firstName} {lastName}
          </Typography>
        </Stack>
      </DashboardPatientContainer>
    </PatientLink>
  );
};

export default DashboardPatientCard;
